import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { H6, Overline, Subtitle1 } from '@src/elements/typography/typography'
import { MenuButton } from '@src/elements/button/button'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import ClassData from '@src/data/class'
import { Card } from '@src/components/card/card'
import { Icon } from '@src/elements/icon/icon'
import { Modal } from '@src/elements/modal/modal'

import './class-card.sass'
import { MobileTooltip } from '@src/elements/tooltip/mobile-tooptip'
import { ClassService } from '@src/service/classes'

@Component
export class ClassCardInfo extends Vue {

  @Prop({ required: true })
  item: ClassData

  private showClassInfo: boolean = false
  private classes: ClassService = new ClassService()

  constructor (props) {
    super(props)
  }

  render (h: CreateElement) {
    return <Card class={`class-card class-card-info ${this.item.hidden ? 'hidden' : ''}`}>
      {this.renderHeader(h)}
      {this.renderPreview(h)}
      {this.renderTitle(h)}
      {this.renderSpecs(h)}
      {this.renderRight(h)}
    </Card>
  }

  renderHeader (h: CreateElement) {
    return <Overline slot='header' class='header'>
      <Icon class='lang' name={`country-flags/${this.item.locale}`} />
      {this.item.contentTypes.map((type) => <div class='class-type'>{`${type} CLASS`}</div>)}
      {this.item.hidden ?
      <MobileTooltip content={this.$t('PAGE.CONTENT.WORKOUT.HIDDEN_WORKOUT')}>
        <Icon class='hidden' name={'workout/hidden-workout'} style={{ marginLeft: '10px' }} />
      </MobileTooltip> : null}
    </Overline>
  }

  renderPreview (h: CreateElement) {
    return <div slot='preview' class='class-preview'>
      <img src={this.item.previewImage} />
    </div>
  }

  renderTitle (h: CreateElement) {
    return <H6 class='title' slot='title' ref='title'>{this.item.name}</H6>
  }

  renderSpecs (h: CreateElement) {
    return <div slot='specs' class='specs'>
      <div class='class-detail'>
        <Icon name='workout/time' />
        <Subtitle1 class='detail-text'>{`${this.item.estimatedDurationInMin} ${this.$t('UNITS.MIN')}`}</Subtitle1>
      </div>
      <div class='class-detail'>
        <Icon name='workout/score' />
        <Subtitle1 class='detail-text'>{this.item.estimatedMetValue} {this.$t('UNITS.MET')}</Subtitle1>
      </div>
    </div>
  }

  renderRight (h: CreateElement) {
    return <div slot='right' class='more-options'>
      <MenuButton>
        <Popover>
          <OptionGroup>
            {this.item.videoSrc && <div class='view-class' onClick={this.showHideInfo}>{this.$t('VIEW')}</div>}
            <div class='hide-class' onClick={this.item.hidden ? this.show : this.hide}>{this.$t(`PAGE.CONTENT.WORKOUT.${this.item.hidden ? 'SHOW' : 'HIDE'}`)}</div>
          </OptionGroup>
        </Popover>
      </MenuButton>
      <Modal show={this.showClassInfo} title={this.item.name} closeCallback={this.showHideInfo} cssClass={'class-info-modal'}>
        <video autoplay='autoplay' controls>
          <source src={this.item.videoSrc} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
        <Subtitle1 class='description'><span domPropsInnerHTML={this.item.description}></span></Subtitle1>
      </Modal>
    </div>
  }

  showHideInfo () {
    this.showClassInfo = !this.showClassInfo
  }

  protected show () {
    if (this.item.id) {
      return this.classes.toggleClassVisibility(this.item.id)
        .then(() => {
          this.item.hidden = false
          this.$store.dispatch('showToast', { message: this.$t('PAGE.CONTENT.WORKOUT.SHOW_SUCCESS_CLASSES'), fadeOut: true })
        })
    }
  }

  protected hide () {
    if (this.item.id) {
      return this.classes.toggleClassVisibility(this.item.id)
        .then(() => {
          this.item.hidden = true
          this.$store.dispatch('showToast', { message: this.$t('PAGE.CONTENT.WORKOUT.HIDE_SUCCESS_CLASSES'), fadeOut: true })
        })
    }
  }
}
